import React, { useEffect, useState, useRef } from 'react';
import './AnimatedGallery.css';

// Import images from different event folders
import ad1 from '../img/Annual Day/IMG_5534.JPG';
import ad2 from '../img/Annual Day/IMG_5587.JPG';
import ad3 from '../img/Annual Day/IMG_5605.JPG';
import ad4 from '../img/Annual Day/IMG_5749.JPG';
import ad5 from '../img/Annual Day/IMG_5768.JPG';
import c1 from '../img/career/IMG_7789.JPG';
import c2 from '../img/career/IMG_7814.JPG';
import c3 from '../img/career/IMG_7837.JPG';
import cy1 from '../img/Cycles/IMG_8310.JPG';
import cy2 from '../img/Cycles/IMG_8323.JPG';

const ALL_IMAGES = [ad1, ad2, ad3, ad4, ad5, c1, c2, c3, cy1, cy2];

// Shuffle array function
function shuffleArray(array) {
  const shuffled = [...array];
  for (let i = shuffled.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [shuffled[i], shuffled[j]] = [shuffled[j], shuffled[i]];
  }
  console.log("Shuffled Images: ", shuffled);
  return shuffled;
}

const IMAGES = shuffleArray(ALL_IMAGES);

// PowerPoint-style transition effects
const EFFECTS = [
  'effect-fade',
 // 'effect-spin',
 // 'effect-wheel',
  'effect-zoom-in',
  'effect-zoom-out',
  'effect-slide-left',
  'effect-slide-right',
  'effect-slide-top',
  'effect-slide-bottom',
  'effect-flip-h',
  'effect-flip-v',
  'effect-diamond',
  'effect-explode',
  'effect-shutter',
  'effect-push',
  'effect-wipe',
  'effect-curtain',
  'effect-blur',
];

function getRandomEffect() {
  return EFFECTS[Math.floor(Math.random() * EFFECTS.length)];
}

export default function AnimatedGallery({ interval = 3500 }) {
  const [index, setIndex] = useState(0);
  const [effect, setEffect] = useState(getRandomEffect());
  const timeoutRef = useRef(null);

  useEffect(() => {
    startTimer();
    return () => stopTimer();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [index]);

  function startTimer() {
    stopTimer();
    timeoutRef.current = setTimeout(() => {
      setEffect(getRandomEffect());
      setIndex((prev) => (prev + 1) % IMAGES.length);
    }, interval);
  }

  function stopTimer() {
    if (timeoutRef.current) clearTimeout(timeoutRef.current);
  }

  function goTo(i) {
    setEffect(getRandomEffect());
    setIndex(i % IMAGES.length);
  }

  function prev() {
    setEffect(getRandomEffect());
    setIndex((prevIdx) => (prevIdx - 1 + IMAGES.length) % IMAGES.length);
  }

  function next() {
    setEffect(getRandomEffect());
    setIndex((prevIdx) => (prevIdx + 1) % IMAGES.length);
  }

  return (
    <section id="gallery" className="container-fluid p-0">
      <div className="ag-container animated-gallery">
        {IMAGES.map((src, i) => (
          <div
            key={i}
            className={`ag-slide ${i === index ? `active ${effect}` : ''}`}
            style={{ backgroundImage: `url(${src})`, height: '100%' }}
            aria-hidden={i === index ? 'false' : 'true'}
          />
        ))}

        <button className="ag-arrow left" onClick={() => { stopTimer(); prev(); }} aria-label="Previous slide">‹</button>
        <button className="ag-arrow right" onClick={() => { stopTimer(); next(); }} aria-label="Next slide">›</button>

        <div className="ag-controls" role="tablist" aria-label="Gallery dots">
          {IMAGES.map((_, i) => (
            <div
              key={i}
              role="tab"
              aria-selected={i === index}
              tabIndex={0}
              className={`ag-dot ${i === index ? 'active' : ''}`}
              onClick={() => { stopTimer(); goTo(i); }}
              onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') { stopTimer(); goTo(i); } }}
            />
          ))}
        </div>
      </div>
    </section>
  );
}
